import api from '@/helpers/api'
class NotificationService{

    async fetch_notifications(page = 1){
        return await api.get(`notifications?page=${page}`).then(
            response => {
                return response.data
            }
        )
    }

}

export default new NotificationService;